<div class="cv-box-item">
  <img
    class="cv-box-item__illustration"
    src="assets/img/cv-box/box-redesign-final.svg"
    width="140"
    height="129"
    alt=""
  />
  <div class="cv-box-item__logo">
    <img
      title="{{ cvBox.customerName }}"
      class="cv-box-item__logo-img"
      [src]="cvBox.logoHref"
      alt="customer-logo"
    />
  </div>
  @if (userType !== userTypeEnum.Internal) {
  <a
    [routerLink]="['/customer', cvBox.customerId, cvBox.urlFriendlyCustomerName]"
    class="cv-box-item__link"
  >
    <button class="cv-box-item__btn">{{ 'label.LeaveCv' | translate }}</button>
  </a>
  }
</div>
